import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "vue-multiselect/dist/vue-multiselect.css"; // ✅ Correct way to import CSS
import "@/assets/css/style.css"; // ✅ Your custom styles

const app = createApp(App);

app.use(router);

app.mount("#app");
/* Q16 Updates - Wed Jan 28 16:24:58 IST 2026 */
